import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksCounterpartyCreationPopupContent.AddressSection', {
    cityTown: 'City/Town',
    cityTownPlaceholder: 'Enter City/Town',
    country: 'Country',
    countyPlaceholder: 'Enter country',
    countyStateProvincePlaceholder: 'Enter County/State/Province',
    countyStateProvince: 'County/State/Province',
    postalCode: 'Postcode',
    postalCodePlaceholder: 'Enter postcode',
    street: 'Address',
    streetAddressPlaceholder: 'Enter address',
});
